import { ActionsCell } from '../../../../Component/Common/Components/DataTable/ActionsCell';
import { DefaultCell } from '../../../../Component/Common/Components/DataTable/DefaultCell';
import { EEReportTable } from '../../../../Component/Model/Dto/EmploymentEquity/Reporting';
import { StaticDataModel } from '../../../../Component/Model/Dto/StaticData';
import { TableDateHelper } from '../../../../Component/Model/helpers';
import { TableColumn } from '../../../../Component/Model/Table/Table';

export const reportTypeList: StaticDataModel[] = [
    { Name: 'EEA2', Id: 1 },
    { Name: 'EEA4', Id: 2 },
    { Name: 'EEA12', Id: 3 },
    { Name: 'EEA13', Id: 4 },
]

export const fileTypeList: StaticDataModel[] = [
    { Name: 'PDF', Id: 1 },
    { Name: 'Word', Id: 2 },
]

interface ReportRow {
    ReportName: string,
    CreatedDate: string,
    ReportStartDate: string,
    ReportEndDate: string,
    CreatedBy: string
    Actions?: any;
}

export interface ReportTable {
    columns: Array<TableColumn>;
    rows: Array<ReportRow>;
}

export const defaultReportColumns = [
    {
        field: 'Date Created',
        headName: 'Date Created',
        width: 180
    },
    {
        field: 'Report Name',
        headName: 'Report Name',
        width: 200
    },
    {
        field: 'Report Start Date',
        headName: 'Report Start Date',
        width: 180
    },
    {
        field: 'Report End Date',
        headName: 'Report End Date',
        width: 180
    },
    {
        field: 'Created By',
        headName: 'Created By',
        width: 200
    },
    {
        field: 'Actions',
        headName: 'Actions',
        width: 140
    }
];

export function EEReportTableMapper(dataObject: EEReportTable.Dto[], handleDownload: (id: string) => void, handleDelete: (id: string) => void): ReportTable {
    const columns = [
        { Header: 'Created Date', accessor: 'CreatedDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Report Name', accessor: 'ReportName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Report Start Date', accessor: 'ReportStartDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Report End Date', accessor: 'ReportEndDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Created By', accessor: 'CreatedBy', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject.length > 0) {

        const rows:ReportRow[] = dataObject.map((item: EEReportTable.Dto) => ({
            Id: item.DocumentId,
            ReportName: item.FileName,
            ReportStartDate: TableDateHelper(item.ReportingStartDate.toString()) ?? "",
            ReportEndDate: TableDateHelper(item.ReportingEndDate.toString()) ?? "",
            CreatedBy: item.UserName,
            CreatedDate: TableDateHelper(item.DateCreated.toString(), true) ?? "",
            Actions: [
                { label: 'Download', action: handleDownload, key: item.DocumentId, icon: { color: 'info', name: 'download' } },
                { label: 'Delete', action: handleDelete, key: item.DocumentId, icon: { color: 'error', name: 'delete' } }]
        }));

        return { columns: columns, rows: rows };

    } else {
        return { columns: columns, rows: [] };
    }
}


